module.exports = {
  conexion: "https://www.athos.com.ve/api",
  //conexion: "http://192.168.100.30:5030",
  servidor: "https://www.athos.com.ve/api",
  pyserver: "https://www.athos.com.ve/sistema",
  titulo: "ATHOS",
  reportes: "https://www.athos.com.ve/api2/athos",
  //reportes: "http://192.168.100.30:4010/athos",
  email: "http://3.141.30.169:5000",
  validar: "https://sygreca.com.ve/api",
  iframe: "https://iframe.athos.com.ve"
};


/* module.exports = {
  conexion: "https://athos-erp.opensiap.com.ve/api",
  servidor: "https://athos-erp.opensiap.com.ve/api",
  pyserver: "https://athos-erp.opensiap.com.ve/sistema",
  titulo: "ATHOS",
  reportes: "https://athos-erp.opensiap.com.ve/api2/athos",
  email: "http://3.141.30.169:5000",
  validar: "https://sygreca.com.ve/api",
}; */


/* module.exports = {
  conexion: "http://localhost:5030",
  pyserver: "https://www.athos.com.ve/sistema",
  titulo: "ATHOS",
  //reportes: "https://www.athos.com.ve/api2/athos",
  reportes: "http://localhost:4010/athos",
  email: "http://3.141.30.169:5000",
  iframe: "https://iframe.athos.com.ve"
}  */



//////////////////
// WEBPACK FOOTER
// ./public/modulos/datos.js
// module id = 8
// module chunks = 0